import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AddCarousels, Carousels } from '../models/carousels/carousels';



@Injectable({
  providedIn: 'root'
})
export class CarouselsService {

  constructor(
    private _http: HttpClient
  ) { }

    public getCarousels(CarouselsId?: number): Observable<Carousels[]>{
        return this._http.get<Carousels[]>(`${environment.api.url}/Carousels?CarouselsId=${CarouselsId??''}`);
    }
  
    public deleteCarousels(CarouselsId: number): Observable<boolean> {
        return this._http.delete<any>(`${environment.api.url}/Carousels/${CarouselsId}`);
    }
  
    public addCarousels(model: AddCarousels): Observable<boolean> {
        return this._http.post<any>(`${environment.api.url}/Carousels`, model);
    }
}
